import React from "react";
import SiteHeader from "../components/home/SiteHeader";
import Hero from "../components/home/Hero";
import MediaStrip from "../components/home/MediaStrip";
import Professions from "../components/home/Professions";
import CommunityPreview from "../components/home/CommunityPreview";
import HowItWorks from "../components/home/HowItWorks";
import Ecosystem from "../components/home/Ecosystem";
import JobsPreview from "../components/home/JobsPreview";
import TrustPrivacy from "../components/home/TrustPrivacy";
import Stories from "../components/home/Stories";
import FinalCTA from "../components/home/FinalCTA";
import SiteFooter from "../components/home/SiteFooter";

export default function Landing() {
  return (
    <div className="min-h-screen bg-[#FDFBF7]" data-testid="landing-page">
      <SiteHeader />
      <Hero />
      <MediaStrip />
      <Professions />
      <CommunityPreview />
      <HowItWorks />
      <Ecosystem />
      <JobsPreview />
      <TrustPrivacy />
      <Stories />
      <FinalCTA />
      <SiteFooter />
    </div>
  );
}
